import i18n from '~/i18n';
import { interTenantApi } from '~/stores/providers/InterTenantApi';

import { api } from './providers/Api2';
import Crypto from './providers/Crypto';
import environment from './providers/environment';
import idb from './providers/Idb';
import logging from './providers/logging';
import popper from './providers/popper';
import { promiseQueue } from './providers/PromiseQueue';
import router from './providers/router';

class Utils {
  initialize = () => {
    this.idb.initialize();
    this.api.initialize();
    this.interTenantApi.initialize();
  };

  crypto = Crypto;
  idb = idb;
  api = api;
  interTenantApi = interTenantApi;
  i18n = i18n;
  uploadQueue = promiseQueue;
  environment = environment;
  popper = popper;
  router = router;
  logging = logging;
}

export default Utils;
